<template>
  <v-container fluid>
    <h1></h1>
    <h1 class="display-inline">WIP Setup</h1>
    <div class="display-inline ml-3">
      <ActiveApiCalls/>
    </div>
    <p>This is a summary of the WIP in WorkflowMax. This is not automatically updated, instead the WIP needs to be
      imported.</p>
    <WIPSetup></WIPSetup>
  </v-container>
</template>

<script>

import WIPSetup from "@/components/invoicing/WIPSetup.vue"
import ActiveApiCalls from "@/components/tools/ActiveApiCalls.vue";

export default {
  name: "WIPSetupPage",
  permissions: [...WIPSetup.permissions],
  components: {ActiveApiCalls, WIPSetup},
  methods: {},
  computed: {},
  mounted() {

  },
  data() {
    return {}
  },
}

</script>

<style scoped>

</style>